(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('MyDomainNotificationDeleteDialogController',MyDomainNotificationDeleteDialogController);

    MyDomainNotificationDeleteDialogController.$inject = ['$timeout', '$scope', '$stateParams', 'entity', '$state', '$uibModalInstance', 'MyDomainNotification'];

    function MyDomainNotificationDeleteDialogController($timeout, $scope, $stateParams, entity, $state, $uibModalInstance, MyDomainNotification) {
        var vm = this;
        vm.myDomainNotification = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            MyDomainNotification.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
